module.exports = __webpack_public_path__ + "img/isignthis.4e35aa60.svg";